import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { useState } from "react";
import { BarChart3, TrendingUp } from "lucide-react";

export function BaselineConfiguration() {
  const [period, setPeriod] = useState("12");
  const [sensitivity, setSensitivity] = useState(80);
  const [autoUpdate, setAutoUpdate] = useState(true);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BarChart3 className="h-5 w-5" />
          Historical Baseline Configuration
        </CardTitle>
        <CardDescription>
          Configure how historical data is analyzed to detect anomalies
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Baseline Period</Label>
            <Select value={period} onValueChange={setPeriod}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="3">Last 3 months</SelectItem>
                <SelectItem value="6">Last 6 months</SelectItem>
                <SelectItem value="12">Last 12 months</SelectItem>
                <SelectItem value="24">Last 24 months</SelectItem>
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              Historical data used to calculate average patterns
            </p>
          </div>

          <div className="space-y-2">
            <Label>Detection Sensitivity: {sensitivity}%</Label>
            <Slider
              value={[sensitivity]}
              onValueChange={([value]) => setSensitivity(value)}
              min={50}
              max={100}
              step={5}
            />
            <p className="text-xs text-muted-foreground">
              Higher sensitivity = more anomalies detected
            </p>
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label>Auto-Update Baselines</Label>
              <p className="text-xs text-muted-foreground">
                Automatically recalculate baselines monthly
              </p>
            </div>
            <Switch checked={autoUpdate} onCheckedChange={setAutoUpdate} />
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <Card>
            <CardContent className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <TrendingUp className="h-4 w-4 text-muted-foreground" />
                <p className="text-sm font-medium">Active Baselines</p>
              </div>
              <p className="text-2xl font-bold">348</p>
              <p className="text-xs text-muted-foreground">Customer-supplier pairs</p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <BarChart3 className="h-4 w-4 text-muted-foreground" />
                <p className="text-sm font-medium">Last Updated</p>
              </div>
              <p className="text-2xl font-bold">2d ago</p>
              <p className="text-xs text-muted-foreground">Next update in 28 days</p>
            </CardContent>
          </Card>
        </div>

        <Button className="w-full">
          Recalculate All Baselines
        </Button>
      </CardContent>
    </Card>
  );
}
